import jQuery from 'jquery';

import ModalInstance from '@/common/components/ModalInstance';

let currently_open_modal;

const { UI, app } = Mobi2Go;

const $html = jQuery('html');
const $body = jQuery('body');
const $view_container = jQuery('.m2g-view');

const container = document.createElement('div');
const overlay = document.createElement('div');

container.classList.add('m2g-view');
container.classList.add(
    app.isMobileUI() ? 'm2g-view--mobile' : 'm2g-view--desktop'
);
container.classList.add('m2g-external-modals');
container.classList.add('m2g-menu-layout—default');
container.classList.add('m2g-menu-products--default');
container.classList.add('m2g-menu-product-images--default');

container.setAttribute('data-external-modals', '');
container.setAttribute('data-platform', Mobi2Go.app.getPlatform());
container.id = 'm2g-view';


overlay.classList.add('m2g-external-modals-overlay');
overlay.classList.add('m2g-external-modals-overlay--modal-closed');

container.appendChild(overlay);
$body.append(container);

const showOverlay = () => {
    overlay.classList.remove('m2g-external-modals-overlay--modal-closed');
    overlay.classList.add('m2g-external-modals-overlay--modal-open');
};

const hideOverlay = () => {
    overlay.classList.remove('m2g-external-modals-overlay--modal-open');
    overlay.classList.add('m2g-external-modals-overlay--modal-closed');
};

const onModalOpen = modal_instance => {
    $view_container
        .removeClass('m2g-view--modal-closed')
        .addClass('m2g-view--modal-open');

    container.classList.remove('m2g-view--modal-closed');
    container.classList.add('m2g-view--modal-open');

    showOverlay();

    $body.addClass('m2g-open-modal m2g-open-external-modal');
    $html.addClass('m2g-open-modal m2g-open-external-modal');

    currently_open_modal = modal_instance;

    UI.trigger('modalOpen', modal_instance);
};

const onModalClose = (modal_instance, retain_overlay) => {
    // TODO: re-enable once all the modals are done using the new system
    if (!retain_overlay) {
        $view_container
            .removeClass('m2g-view--modal-open m2g-view--modal-frozen')
            .addClass('m2g-view--modal-closed');

        container.classList.remove('m2g-view--modal-open');
        container.classList.add('m2g-view--modal-closed');

        hideOverlay();
    }

    $body.removeClass('m2g-open-modal m2g-open-external-modal');
    $html.removeClass('m2g-open-modal m2g-open-external-modal');

    currently_open_modal = null;

    UI.trigger('modalClose', modal_instance);
};

const onModalIsClosableChange = is_closable => {
    if (is_closable) {
        $view_container.removeClass('m2g-view--modal-frozen');
        $body.removeClass('m2g-open-modal--frozen');
    } else {
        $view_container.addClass('m2g-view--modal-frozen');
        $body.addClass('m2g-open-modal--frozen');
    }
};

$body.keyup(e => {
    if (currently_open_modal && e.key === 'Escape') {
        currently_open_modal.close();
    }
});

UI.ExternalModal = {
    create: (id, element, options) => {
        const modal_container = document.createElement('div');
        modal_container.setAttribute('data-modal-id', id);

        container.appendChild(modal_container);

        const modal_instance = new ModalInstance(
            element,
            modal_container,
            options
        );

        modal_instance.bind('open', () => onModalOpen(modal_instance));
        modal_instance.bind('close', retain_overlay =>
            onModalClose(modal_instance, retain_overlay)
        );
        modal_instance.bind('isClosableChange', onModalIsClosableChange);

        return modal_instance;
    },

    isOpen: () => !!currently_open_modal,

    forceClose: () =>
        currently_open_modal && currently_open_modal.close(false, true),

    scrollToTop: () =>
        currently_open_modal && currently_open_modal.scrollToTop(),
};
